export const gateway = "https://qat-standard-bms-api.link-nonprod.wawanesalife.com";
export const LoginUrlParameter = "https://qat-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=4ojek7qpra6m5jiig0a0lvjqkd&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fqat-standard-bms.link-nonprod.wawanesalife.com%2Fredirect";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "4ojek7qpra6m5jiig0a0lvjqkd";
export const BrokerPoolDomainParameter = "qat-brokers";
export const BrokerPoolParameter = "ca-central-1_f0PTGfA8O";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://qat-standard-shopper.link-nonprod.wawanesalife.com";

//updated on Mon Sep 15 2025 16:12:11 GMT+0000 (Coordinated Universal Time)
